export default __webpack_public_path__ + "static/media/showcaseHero.99538d48.jpeg";